import { connect } from 'react-redux'
import { find } from 'lodash'
import { browserHistory } from 'react-router'
import configpath from 'configpath'

import { buildEmail } from 'utils/BuildEmail'

import {
  postEmail,
} from 'reduxpath/ducks/Email'

import {
  setPortfolioAction,
  putPortfolioStatus,
  postRejectReason,
  setSelectedClean,
} from 'reduxpath/ducks/Product/Portfolio'

import {
  putProduct,
} from 'reduxpath/ducks/Product/Detail'

import SetStatus from './units'

const mapStateToProps = (state) => {
  const portfolioStatus = state.ProductList.status
  return {
    statusList: portfolioStatus,
    product: state.ProductDetail.data,
    portfolio: state.ProductPortfolio,
    status: find(portfolioStatus, { value: state.ProductPortfolio.data.status })
      || state.ProductList.status.onReview,
    isLoading: state.ProductPortfolio.isLoading,
    userId: state.Auth.me.user.id,
  }
}

const mapDispatchToProps = dispatch => ({
  handleInputChange() {
    return (e) => {
      const data = {
        field: e.target.name,
        value: e.target.value,
      }
      dispatch(setPortfolioAction(data))
    }
  },
  handleStatus(statusList) {
    return (e) => {
      const data = {
        field: e.target.name,
        value: statusList[e.target.value].value,
      }
      dispatch(setPortfolioAction(data))
    }
  },
  submitStatus(portfolio, selected, userId, statusList, product) {
    return (e) => {
      e.preventDefault()
      const data = selected
      const currentURL = window.location.pathname
      const redirectUrl = currentURL.split('/')[1]
      if (data.status === statusList.approved.value &&
        product.status === statusList.approved.value) {
        dispatch(putProduct(product.id, {
          isEligible: true,
        }))
      }
      if (data.status === statusList.rejected.value) {
        const rejectReason = {
          portfolio: portfolio.data.id,
          rejectReason: data.rejectReason,
          createdBy: userId,
        }
        dispatch(
          postRejectReason(rejectReason, () => {
            const params = {
              user: {
                email: product.createdBy.email,
                firstName: product.createdBy.firstName,
                profileId: product.profile.profileId,
              },
              product: {
                name: product.name,
                id: product.id,
                slug: product.slug,
              },
              portfolio: {
                name: portfolio.data.title,
              },
              rejectReason: data.rejectReason,
            }

            const wispPublicUrl = configpath.wisp_public_url
            const handlebars = {
              name: params.user.firstName,
              email: params.user.email,
              service_title: params.product.name,
              sample_title: params.portfolio.name,
              reason: params.rejectReason,
              sample_link: `${wispPublicUrl}/review-redirect/${params.user.profileId}/${params.product.slug}`,
            }
            const emailData = {
              recipient: [{
                name: params.user.firstName,
                email: params.user.email,
              }],
              category: 'sample-rejected',
              type: 'creator',
              handlebars,
            }
            dispatch(postEmail(buildEmail(emailData)))
          }),
        )
      }
      return dispatch(
        putPortfolioStatus(portfolio.data.id, {
          status: data.status,
          reviewedBy: userId,
        }, () => {
          dispatch(setSelectedClean())
          browserHistory.push(`/${redirectUrl}/${product.id}`)
        }),
      )
    }
  },
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SetStatus)
